// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 560) return "js/560.js";
	if (chunkId === 354) return "js/354.js";
	if (chunkId === 418) return "js/418.js";
	if (chunkId === 755) return "js/755.js";
	// return url for filenames based on template
	return undefined;
};